/**
 * Generates a cache key for conversation stream data.
 * When binary is true, a different key is used so toggling the wire format
 * doesn't mix cached JSON bytes with binary bytes mid-stream.
 */
export function getConversationCacheKey(agentExecutionId: string, binary?: boolean): string {
    if (binary) {
        return `conversation:bin:${agentExecutionId}`;
    }
    return `conversation:${agentExecutionId}`;
}
